module.exports = __webpack_public_path__ + "static/media/new_car.60fbf92c.obj";